import types from './types';
import paySimpleService, {
  IEcheckPayment
} from 'src/services/paySimple/paySimpleService';

import { IPaySimpleError } from './reducers';

import { invoicesActions } from '../invoices';

const createPayment = (params: IEcheckPayment) => (
  dispatch: any,
  getState: any
) => {
  dispatch(setIsPending(true));
  dispatch(setError());
  paySimpleService
    .createECheckPayment(params)
    .then(res => {
      dispatch(invoicesActions.getInvoices());
      dispatch(setAuthorized(res.authorized));
      dispatch(setTrackingNumber(res.trackingNumber));
      dispatch(invoicesActions.clearSelectedInvoices());
      dispatch(setIsPending(false));
      dispatch(setShowStatusModal(true));
    })
    .catch(error => {
      dispatch(setErrorMessage(error.response.data.message));
      dispatch(setIsPending(false));
      dispatch(setShowStatusModal(true));
      dispatch(
        setError({
          hasFailed: true,
          message: error.message
        })
      );
    });
};

const closeStatusModal = () => (dispatch: any) => {
  dispatch(setAuthorized(false));
  dispatch(setTrackingNumber(''));
  dispatch(setShowStatusModal(false));
};

const setAuthorized = (authorized: boolean) => {
  return {
    type: types.SET_PAYSIMPLE_PAYMENT_IS_AUTHORIZED,
    payload: authorized
  };
};

const setTrackingNumber = (trackingNumber: string) => {
  return {
    type: types.SET_PAYSIMPLE_PAYMENT_TRACKING_NUMBER,
    payload: trackingNumber
  };
};

const setErrorMessage = (errorMessage: string) => {
  return {
    type: types.SET_PAYSIMPLE_PAYMENT_ERROR_MESSAGE,
    payload: errorMessage
  };
};

const setIsPending = (isPending: boolean) => {
  return { type: types.SET_PAYSIMPLE_PAYMENT_IS_PENDING, payload: isPending };
};

const setError = (error?: IPaySimpleError) => {
  return {
    type: types.SET_PAYSIMPLE_PAYMENT_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const setShowStatusModal = (showStatusModal: boolean) => {
  return {
    type: types.SET_PAYSIMPLE_PAYMENT_SHOW_STATUS_MODAL,
    payload: showStatusModal
  };
};

export default {
  createPayment,
  closeStatusModal
};
